import '../css/news-press.css';

(function () {
    const content = document.getElementById('np-content');
    if (!content) return;

    const cfg = window.npFilter;
    if (!cfg) return;

    // Current filter state — initialised from the URL on page load.
    const qs0 = new URLSearchParams(window.location.search);
    let state = {
        section : qs0.get('section') === 'press' ? 'press' : 'news',
        cat     : qs0.get('cat')  || '',
        np_s    : qs0.get('np_s') || '',
    };

    let busy = false;

    // ── Fetch & render ────────────────────────────────────────────────────
    async function load(params, pushHistory) {
        if (pushHistory === undefined) pushHistory = true;
        if (busy) return;
        busy = true;
        content.style.opacity = '0.5';

        try {
            const qs = new URLSearchParams();
            qs.set('action',   cfg.action);
            qs.set('section',  params.section  || 'news');
            qs.set('cat',      params.cat      || '');
            qs.set('np_s',     params.np_s     || '');
            qs.set('per_page', String(cfg.perPage || 20));
            qs.set('lang',     cfg.lang || 'en');
            if (params.paged > 1) qs.set('paged', String(params.paged));

            const res  = await fetch(cfg.ajaxUrl + '?' + qs.toString());
            const json = await res.json();
            if (json && json.success && json.data && json.data.html) {
                content.innerHTML = json.data.html;
                // Reveal animation observer only runs on initial page load.
                // For AJAX-injected cards make them visible immediately.
                content.querySelectorAll('.reveal').forEach(function (el) {
                    el.classList.add('visible');
                });
            }
        } catch (err) {
            console.error('[np-filter] fetch error:', err);
        }

        content.style.opacity = '';
        busy = false;

        if (pushHistory) {
            const urlParams = new URLSearchParams();
            if (params.section === 'press') urlParams.set('section', 'press');
            if (params.cat)                 urlParams.set('cat',     params.cat);
            if (params.np_s)                urlParams.set('np_s',    params.np_s);
            const search = urlParams.toString() ? '?' + urlParams.toString() : '';
            history.pushState(params, '', window.location.pathname + search);
        }
    }

    // ── Update section tab active styles ──────────────────────────────────
    function updateSectionTabStyles(section) {
        document.querySelectorAll('[data-np-section]').forEach(function (tab) {
            var active = tab.getAttribute('data-np-section') === section;
            tab.style.color             = active ? cfg.colorActive : cfg.colorInactive;
            tab.style.borderBottomColor = active ? cfg.colorActive : 'transparent';
        });
    }

    // ── Single consolidated click handler ─────────────────────────────────
    document.addEventListener('click', function (e) {
        // Section tab (News / Press Room)
        var sectionTab = e.target.closest('[data-np-section]');
        if (sectionTab) {
            e.preventDefault();
            var section = sectionTab.getAttribute('data-np-section');
            if (section === state.section) return;
            state = { section: section, cat: '', np_s: state.np_s };
            updateSectionTabStyles(section);
            load(state);
            return;
        }

        // Category filter tab (All / Latest News / …)
        var catTab = e.target.closest('[data-np-cat]');
        if (catTab) {
            e.preventDefault();
            var cat = catTab.getAttribute('data-np-cat');
            if (cat === state.cat) return;
            state = { section: state.section, cat: cat, np_s: state.np_s, paged: 1 };
            load(state);
            return;
        }

        // Pagination link (inside #np-content, href contains "paged")
        var pageLink = e.target.closest('a');
        if (pageLink && content.contains(pageLink) && pageLink.href.indexOf('paged') !== -1) {
            e.preventDefault();
            var url   = new URL(pageLink.href);
            var paged = parseInt(url.searchParams.get('paged') || '1', 10);
            load({ section: state.section, cat: state.cat, np_s: state.np_s, paged: paged });
            return;
        }
    });

    // ── Search ────────────────────────────────────────────────────────────
    var searchTimer;
    document.addEventListener('input', function (e) {
        if (e.target.id !== 'np-search') return;
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
            var np_s = e.target.value.trim();
            if (np_s === state.np_s) return;
            state = { section: state.section, cat: '', np_s: np_s, paged: 1 };
            load(state);
        }, 400);
    });

    // Prevent the search form from doing a hard submit.
    document.addEventListener('submit', function (e) {
        if (e.target.id === 'np-search-form') e.preventDefault();
    });

    // ── Browser back / forward ────────────────────────────────────────────
    window.addEventListener('popstate', function (e) {
        var s = (e.state) || {};
        state = {
            section : s.section || 'news',
            cat     : s.cat     || '',
            np_s    : s.np_s    || '',
        };
        updateSectionTabStyles(state.section);
        load(state, false);
    });
})();
